/**
 * @fileoverview Custom hook for clearing and canceling React Query cache.
 */

import {useQueryClient} from "react-query";
import {useCallback} from "react";

/**
 * Custom hook that provides a function to clear and cancel all React Query cache.
 * Useful for logging out users or resetting application state.
 *
 * @returns {Object} Object containing the cache clearing function.
 * @returns {Function} returns.clearAndCancelCache Function to clear and cancel all cache.
 */
export const useClearAndCancelCache = () => {
  const cache = useQueryClient();

  const clearAndCancelCache = useCallback(() => {
    cache.clear();
    cache.cancelQueries();
    cache.cancelMutations();
  }, [cache]);

  return {clearAndCancelCache};
};
